import _ from "lodash";
import Vue from "vue";
import CustomerService from "@/services/customer.service";
import router from "@/router";
import $const from "@/utils/const";
import {getField, updateField} from "vuex-map-fields";
import AppService from "@/services/app.service";
import moment from "moment";
import {make} from "vuex-pathify";

const state = () => ({
    currentCustomer: {},
    loading: false,
    overview: {
        waiting: 0,
        supporting: 0,
        agentServed: 0,
        autoMADServed: 0
    },
    selectedChannels: [...Object.values($const.INTEGRATION_CHANNEL)],
    overviewFilter: {
        channel: '',
        from: moment().subtract(6, 'day').format('YYYY-MM-DD'),
        to: moment().format('YYYY-MM-DD')
    }

});
const mutations = {
    ...make.mutations(state),
    updateField,
    setCurrentCustomer(state, payload) {
        state.currentCustomer = payload
    },
    updateCurrentCustomer(state, payload) {
        for (let key of Object.keys(payload)) {
            Vue.set(state.currentCustomer, key, payload[key])
        }
    },
    setOverview(state, payload) {
        state.overview = payload
    },
    setLoading(state, payload) {
        state.loading = payload
    },
};
const actions = {
    ...make.actions(state),
    getOverview({commit, state}, channels) {
        const botCode = router.currentRoute.params.bot_code;
        if (botCode) {
            const fromIso = moment(state.overviewFilter.from).toISOString()
            const toIso = moment(state.overviewFilter.to).add(1, 'd').toISOString()
            commit('setLoading', true)
            CustomerService.getCustomerOverview(botCode, channels, fromIso, toIso)
                .then(res => {
                    commit('setOverview', res.data)
                })
                .catch(() => {
                    AppService.toastError("Fetch overview customer failure");
                })
                .finally(()=> {
                    commit('setLoading', false)
                })
        }
    },
    openLoading(context) {
        context.commit('setLoading', true)
    },
    closeLoading(context) {
        context.commit('setLoading', false)
    },
    processRequestSupport({state}, payload) {
        if (state.selectedChannels.includes(payload.data.channel)) {
            // Waiting là trạng thái người dùng yêu cầu hỗ trợ nhưng chưa có agent hỗ trợ
            Vue.set(state.overview, 'waiting', state.overview.waiting + 1);
        }
    },
    processAssignAction({state}, payload) {
        if (!state.selectedChannels.includes(payload.data.channel)) {
            return;
        }
        // Trạng thái trước đó của sender có phải là request support hay không
        const isRequestSupport = payload.data.is_request_support;
        // Có phải auto assign không (Trường hợp assgin ngay sau khi có request support -> Không có event user_request_support)
        const isAutoAssign = payload.data.is_auto_assign;
        if (isAutoAssign) {
            Vue.set(state.overview, 'supporting', state.overview.supporting + 1);
        }
        else {
            // Nếu trước đó là request support -> waiting - 1, supporting + 1
            if (isRequestSupport) {
                Vue.set(state.overview, 'waiting', (state.overview.waiting -1 >= 0 ? state.overview.waiting -1 : 0));
                Vue.set(state.overview, 'supporting', state.overview.supporting + 1);
            }
            else {
                Vue.set(state.overview, 'supporting', state.overview.supporting + 1);
            }
        }

    },
    processMAD({state}, payload) {
        if (!state.selectedChannels.includes(payload.data.channel)) {
            return;
        }
        //Trạng thái trước khi MAD của sender là đang được hỗ trợ hay không
        const isSupporting = payload.data.is_supporting
        if (isSupporting) {
            Vue.set(state.overview, 'supporting', (state.overview.supporting - 1 >= 0 ? state.overview.supporting - 1 : 0));
        }
        else {
            Vue.set(state.overview, 'waiting', (state.overview.waiting - 1 >= 0 ? state.overview.waiting - 1 : 0));
        }
    }
};
const getters = {
    getField,
    concurrentCustomers(state) {
        const totalWaiting = state.overview.waiting;
        const totalSupporting = state.overview.supporting;
        const total = totalWaiting + totalSupporting;
        if (total > 0) {
            return [
                {
                    label: "Customer Waiting",
                    value: totalWaiting,
                    rate: `${((totalWaiting / total) * 100).toFixed(2)} %`
                },
                {
                    label: "Customer Supporting",
                    value: totalSupporting,
                    rate: `${((totalSupporting / total) * 100).toFixed(2)} %`
                }
            ]
        }
        return []
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
